export function initCalendarButton() {
	function tryInject() {
		const placeholder = document.getElementById("calendar-button-injection");
		if (!placeholder) return false;

		const label = placeholder.getAttribute("data-label");
		const url = placeholder.getAttribute("data-url");
		if (!label || !url) return false;

		const container = document.querySelector(".ituBanner.event .buttons");
		if (!container) return false;
		if (container.querySelector("#magictools-extra-btn")) return true;

		const calendarLink = Array.from(container.querySelectorAll("a")).find((a) =>
			/add event to my calendar/i.test(a.textContent.trim())
		);

		const link = document.createElement("a");
		link.className = "ituBtn";
		link.id = "magictools-extra-btn";
		link.textContent = label;
		link.href = url;
		link.target = "_blank";
		link.rel = "noopener noreferrer";

		if (calendarLink) {
			calendarLink.insertAdjacentElement("afterend", link);
		} else {
			container.appendChild(link);
		}
		return true;
	}

	function startInjectionLoop() {
		const start = Date.now();
		const timer = setInterval(() => {
			const done = tryInject();
			if (done) clearInterval(timer);
			if (Date.now() - start > 10000) clearInterval(timer);
		}, 400);
	}

	function initWatcher() {
		startInjectionLoop();
		const obs = new MutationObserver(() => {
			if (document.getElementById("magictools-extra-btn")) return;
			startInjectionLoop();
		});
		obs.observe(document.body, { childList: true, subtree: true });
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", initWatcher);
	} else {
		requestAnimationFrame(initWatcher);
	}
}
